<template>
  <div class="done_button_container" :class="{ is_posted }">
    <a @click="done" class="button is-info" :class="{ 'is-outlined': !is_posted }">Done</a>
  </div>
</template>
<script>
export default {
  name: 'alert-done-button',
  props: ['payload'],
  data () {
    return {
      is_posted: false
    }
  },
  methods: {
    done () {
      this.$network_utils.postDoneAlert(this.payload, 'done')
      this.is_posted = true
    }
  }
}
</script>
<style scoped>
  .done_button_container {
    margin-top: 5px;
  }
  .done_button_container a {
    color: #333 !important;
  }
  .done_button_container.is_posted a {
    color: white !important;
  }
</style>
